import React from "react";
import UploadComponent from "../UI/Upload/UploadComponent";

const UcitajDokumentRjesenja = ({
  selectedFiles,
  uploadHandler,
}) => {
  return (
    <>
    <div className="ucitaj_dokument_rjesenja">
      <label htmlFor={"upload-doc"}>Učitaj dokument</label>

      <UploadComponent
        key={"upload-doc"}
        id={"upload-doc"}
        onChange={uploadHandler}
        fileList={selectedFiles}
        accept="application/pdf,image/x-png,image/jpeg"
      />
    </div>
    </>
  );
};

export default UcitajDokumentRjesenja;
